<template>

    <form-section @submitted="updateProfileInformation">

        <template #title>

            <font-awesome-icon class="text-blue mr-6"
                style="width: 27px; height: 27px"
                :icon="['fas', 'user']">
            </font-awesome-icon>

            <div class="text-3xl font-nexa text-blue">
                {{ __('User') }}
            </div>

        </template>


        <template #form>

            <div class="col-span-6 sm:col-span-2">

                <Label class="text-black text-lg font-nexa mb-2"
                    for="name" :value=" __('Name') "/>

                <Input class="w-full text-black"
                    id="name" type="text" v-model="form.name" autocomplete="name" />

                <InputError class="mt-2"
                    :message="form.errors.name" />

            </div>


            <div class="col-span-6 sm:col-span-2">

                <Label class="text-black text-lg font-nexa mb-2"
                    for="email" :value="__('Email')" />

                <Input class="w-full text-black"
                    id="email" type="text" v-model="form.email" />

                <InputError class="mt-2"
                    :message="form.errors.email" />

            </div>


            <div class="col-span-6 sm:col-span-2">

                <Label class="text-black text-lg font-nexa mb-2"
                    for="language"
                    :value="__('Language')" />

                <select class="block ring-0 focus:ring-blue border-gray-300 text-lg font-nexa rounded-md px-6 pt-5 pb-4 w-full text-black"
                    v-model="form.language">

                    <option v-for="language in languages"
                        :value="language.id">

                        {{ language.name }}

                    </option>

                </select>

            </div>

        </template>


        <template #actions>

            <Button class=""
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing">
                {{ __('Save changes') }}
            </Button>

            <ActionMessage class="ml-4"
                :on="form.recentlySuccessful"
                type="success">
                {{ __('Saved') }}
            </ActionMessage>

            <Button class="ml-auto px-1 sm:px-4"
                type="button"
                @click="handle_click_reset_todays_exercises">
                {{ __('Reset todays exercises') }}
            </Button>

        </template>


    </form-section>

</template>

<script>
import { defineComponent } from 'vue'
import Button from '@/Components/Button.vue'
import FormSection from '@/Components/FormSection.vue'
import Input from '@/Components/Input.vue'
import InputError from '@/Components/InputError.vue'
import Label from '@/Components/Label.vue'
import SecondaryButton from '@/Components/SecondaryButton.vue'
import ActionMessage from "../../../Components/ActionMessage";

export default defineComponent({

    components: {
        ActionMessage,
        Button,
        FormSection,
        Input,
        InputError,
        Label,
        SecondaryButton,
    },


    props: {
        user: {
            type: Object
        }
    },


    data() {
        return {
            form: this.$inertia.form({
                _method: 'PUT',
                name: this.user.name,
                email: this.user.email,
                language: this.user.language
            }),
            languages: [
                {
                    id: 'da',
                    name: 'Dansk'
                },
                {
                    id: 'en',
                    name: 'English'
                },
            ],
            photoPreview: null,
            reset_success: false
        }
    },

    methods: {

        updateProfileInformation() {

            this.form.post( this.route('user-profile-information.update'), {
                errorBag: 'updateProfileInformation',
                preserveScroll: true,
            });

        },


        handle_click_reset_todays_exercises() {

            this.$inertia.patch(
                this.route('user_reset_todays_target_steps'),
                {},
                {
                    preserveScroll: true,
                    onSuccess: () => {

                        this.$inertia.visit(
                            route('your_exercises')
                        );

                    },
                }
            );

        }
    },
})
</script>
